var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.61 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #29a829;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.2,36.5h4.7v-4.7h14.1v4.7h4.7l3.64-12.11,5.76-1.94V14.17h-2.35L28.53,5.94c0-.78,.05-1.54,.15-2.26s.26-1.45,.49-2.18c-1.14,.31-2.13,.86-2.97,1.64-.85,.78-1.5,1.71-1.95,2.8H9.85c-2.13,0-4.21,.77-5.76,2.23-1.73,1.64-2.59,3.64-2.59,5.99,0,3.84,.53,7.59,1.59,11.25s2.1,7.36,3.11,11.08Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.93,
    y1: 12.57,
    x2: 19.86,
    y2: 12.57
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl);
export default __webpack_public_path__ + "static/media/control.404b1b63052b8e910bbaa298cf6e02cb.svg";
export { ForwardRef as ReactComponent };